
/**
 * 反馈动作与事件触发映射关系
*/
const actionsMap = {
    invokeShare: 'share',
    location: 'location',
    download: 'downloadFile',
    dialog: 'dialog',
    dial: 'dial',
    anchor: 'anchor',
    customEvent: 'customEvent',
    market: 'location',
    bridge: 'bridge',
    visibleControl: 'visibleControl',
    dataSource: 'dataSource',
    launchApp: 'launchApp',
    multiLocation: 'multiLocation',
    copyText: 'copyText',
    jump: 'jump',
    jumpPageRouter: 'jumpPageRouter',
}
// 汇总事件触发方法 + 去重
const actionNames = Object.values(actionsMap).filter((ele, index, arr) => arr.indexOf(ele) === index)

/**
* 加载事件触发方法
*/
const moduleAction = {}

const actionConText = require.context('../general-event-list', true, /\.js$/)
actionConText.keys().forEach((item) => {
    const actionName = item.split('/')[1].split('.')[0]
    if (actionNames.indexOf(actionName) !== -1) {
        const actionModule = actionConText(item).default || actionConText(item)
        moduleAction[actionName] = actionModule
    }
})

/**
* 分别触发各个事件
* @param {Object} eventData 事件配置
*/
function resolveEvent (eventData = {}) {
    const action = eventData.action
    setTimeout(() => {
        if (actionsMap[action]) {
            moduleAction[actionsMap[action]](eventData)
        } else {
            console.log('no function')
        }
    }, 100)
}

export default resolveEvent
